<template>
  <EditorShell
    ref="shell"
    :items="shellItems"
    item-label="deployment"
    @remove="onShellRemove"
  >
    <!-- Custom list item: thumbnail needs an @error handler -->
    <template #list-item="{ item }">
      <img
        :src="item.thumbnailUrl"
        class="ve-list-thumb"
        :alt="item.name"
        @error="$event.target.style.opacity='0'"
      />
      <span class="ve-list-name">{{ item.name }}</span>
    </template>

    <template #add-panel>
      <p class="ve-hint">Click a deployment layout to add it to the list.</p>
      <div class="dep-image-grid">
        <div
          v-for="img in deploymentImages"
          :key="img"
          class="dep-image-option"
          @click="addDeployment(img)"
        >
          <img :src="'/Images/Deployments/' + img" :alt="img" class="dep-image-thumb" />
        </div>
      </div>
    </template>

    <template #edit-panel="{ idx, openLightbox }">
      <div class="ve-edit-form">
        <div class="ve-edit-row-head">
          <img :src="'/Images/Deployments/' + selectedDeployments[idx].img" class="ve-edit-thumb-wide" @click="openLightbox('/Images/Deployments/' + selectedDeployments[idx].img)" />
          <div>
            <div class="ve-edit-skin-name">Deployment layout {{ parseInt(selectedDeployments[idx].img) }}</div>
            <div class="ve-edit-hint">Deployment {{ idx + 1 }} of {{ selectedDeployments.length }}</div>
          </div>
        </div>
        <div class="ve-edit-group">
          <label class="ve-edit-label">Name</label>
          <input v-model="selectedDeployments[idx].name" type="text" class="field-input" @input="emitChange" />
        </div>
        <div class="ve-edit-group">
          <label class="ve-edit-label">X</label>
          <input v-model.number="selectedDeployments[idx].x" type="number" step="1" class="field-input" @input="emitChange" />
        </div>
        <div class="ve-edit-group">
          <label class="ve-edit-label">Y</label>
          <input v-model.number="selectedDeployments[idx].y" type="number" step="1" class="field-input" @input="emitChange" />
        </div>
        <div class="ve-edit-group">
          <label class="ve-edit-label">Z</label>
          <input v-model.number="selectedDeployments[idx].z" type="number" step="1" class="field-input" @input="emitChange" />
        </div>
      </div>
    </template>
  </EditorShell>
</template>

<script>
import EditorShell from '@/components/EditorShell.vue';

export default {
  name: 'DeploymentsEditor',
  components: { EditorShell },

  props: {
    value: { type: Array, default: () => [] },
  },

  data() {
    return {
      selectedDeployments: [],
      deploymentUidCounter: 0,
    };
  },

  computed: {
    deploymentImages() {
      return Array.from({ length: 14 }, (_, i) => `${i}.jpg`);
    },
    shellItems() {
      return this.selectedDeployments.map(dep => ({
        id: dep.uid,
        thumbnailUrl: '/Images/Deployments/' + dep.img,
        name: dep.name,
      }));
    },
  },

  mounted() {
    if (this.value && this.value.length > 0) {
      this.initFromValue(this.value);
    }
  },

  watch: {
    value(newVal) {
      this.initFromValue(newVal);
    },
  },

  methods: {
    initFromValue(deployments) {
      this.deploymentUidCounter = 0;
      this.selectedDeployments = (deployments || []).map(dep => ({
        uid: this.deploymentUidCounter++,
        img: dep.deploymentID + '.jpg',
        name: dep.deploymentName || ('Deployment ' + this.deploymentUidCounter),
        x: dep.X || 0,
        y: dep.Y || 0,
        z: dep.Z || 0,
      }));
    },

    addDeployment(img) {
      const uid = this.deploymentUidCounter++;
      const defaultName = 'Deployment ' + (this.selectedDeployments.length + 1);
      this.selectedDeployments.push({ uid, img, name: defaultName, x: 0, y: 0, z: 0 });
      this.$refs.shell.selectIdx(this.selectedDeployments.length - 1);
      this.emitChange();
    },

    onShellRemove(item, idx) {
      this.selectedDeployments.splice(idx, 1);
      this.emitChange();
    },

    emitChange() {
      this.$emit('input', this.buildDeploymentsJson());
    },

    buildDeploymentsJson() {
      return this.selectedDeployments.map(dep => {
        const entry = { deploymentID: parseInt(dep.img), deploymentName: dep.name };
        if (dep.x) entry.X = dep.x;
        if (dep.y) entry.Y = dep.y;
        if (dep.z) entry.Z = dep.z;
        return entry;
      });
    },
  },
};
</script>

<style>
.dep-image-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(110px, 1fr)); gap: 0.6rem; margin-top: 0.5rem; }
.dep-image-option { position: relative; border: 2px solid #30363d; border-radius: 6px; cursor: pointer; overflow: hidden; transition: border-color 0.15s; }
.dep-image-option:hover { border-color: #58a6ff; }
.dep-image-thumb { width: 100%; aspect-ratio: 4/3; object-fit: cover; display: block; }
</style>
